'use strict';

const { h } = require('preact');

const PriceLabel = ({
  option: {
    isUrgencyPricing,
    pricing: { pricingLabel },
  },
  showPriceLabel,
  isRefreshLeftAlign,
}) => {
  if (!pricingLabel || !showPriceLabel) {
    return null;
  }

  return h(
    'span',
    {
      class: `price-label ${
        isRefreshLeftAlign && isUrgencyPricing ? 'c-txt-err' : ''
      }`,
    },
    pricingLabel
  );
};

module.exports = PriceLabel;
